export default {
    dashboard: {
        totalWordsGenerated: 'Totaal gegenereerde woorden',
        wordsPerDay: 'Woorden/dag',
        content: 'Content',
        date: 'Datum',
        variationCount: 'Variatie Telling',
        transactionId: 'Transactie ID',
        totalWordsCount: 'Totaal aantal woorden',
        action: 'Actie',
        goTo: 'Go naar',
        viewMore: 'Bekijk meer',
        showLess: 'Toon minder',
        tabImage: 'Afbeelding',
        tabText: 'Tekst',
        dashboardSubtitle: 'Beheer uw door AI gegenereerde inhoud',
        type: 'Type',
    },
};
